import Card from '@zenbusiness/zui/Card';
import Grid from '@zenbusiness/zui/Grid';
import PageContainer from '@zenbusiness/zui/PageContainer';
import PageHeader from '@zenbusiness/zui/PageHeader';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

const INFO_LENGTH = 6;
const ITEM_LENGTH = 2;

function BusinessProfileSkeleton() {
  return (
    <PageContainer sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Skeleton width="30%" height="3rem" />
      <PageHeader
        title={<Skeleton width="50%" height="5rem" />}
        sx={{ mb: 0 }}
      />
      <Card size="lg" sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Skeleton width="30%" height="3rem" />
        <Grid container spacing={3}>
          {Array(INFO_LENGTH).fill(null).map((_, i) => (
            <Grid item xs={12} md={6} key={`info-${i.toString()}`}>
              <Stack spacing={0.5}>
                <Skeleton width="40%" height="2rem" />
                {Array(ITEM_LENGTH).fill(null).map((__, j) => (
                  <Skeleton width="80%" height="1rem" key={`item-${j.toString()}`} />
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Card>
    </PageContainer>
  );
}

export default BusinessProfileSkeleton;
